import * as Yup from 'yup'

export const schema = Yup.object().shape({
  ticket_team_id: Yup.string(),
  members: Yup.array().required('members are required'),
});